import IconButton from './IconButton.vue';

IconButton.install = (Vue) => {
  Vue.component(IconButton.name, IconButton);
};

export default IconButton;
